// removed by extract-text-webpack-plugin
module.exports = {"button":"button_1yXFy","successMessage":"successMessage_3VbmT","errorMessage":"errorMessage_37a3l","loader":"loader_1MH0-"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PageReset/style.css
// module id = 192
// module chunks = 0